module.exports = __webpack_public_path__ + "media/images/easy-steps-3-4fd1776b89e7c77c262da11c67f55a38.png";